import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { Button } from 'components/Button/Button'

type EmptyFeedPostProps = {
    listId?: string
    isDefaultList?: boolean
}

export const EmptyFeedPost = ({
    listId,
    isDefaultList = true,
}: EmptyFeedPostProps) => {
    const { t } = useTranslation()
    const navigate = useNavigate()

    const buttonText = isDefaultList
        ? 'Browse Creators'
        : 'Add Creators'

    const message = isDefaultList
        ? t('clickHereToBrowseOurCreators')
        : 'No Subscriptions Exist In Selected List'

    const handleClick = () => {
        if (isDefaultList) {
            navigate('/creators')
            return
        }

        navigate(`/subscriptions/${listId}`)
    }

    return (
        <div className='post-tags-wrapper'>
            <div className='post__files__file post__files__file--empty'>
                <div className='post__cta'>
                    <p className='post__cta__text'>{message}</p>

                    <Button
                        text={buttonText}
                        color='black'
                        font='mont-14-bold'
                        height='3'
                        width='max-fit'
                        padding='2'
                        customClass='post__cta__button'
                        clickFn={handleClick}
                    />
                </div>
            </div>
        </div>
    )
}